"use client";

import { TERMS_TEXT, PRIVACY_TEXT, MARKETING_TEXT } from "../lib/legalText";

export type TermsState = { terms: boolean; privacy: boolean; marketing: boolean };

function Row({ checked, onChange, required, label, text }: { checked: boolean; onChange: (v: boolean) => void; required: boolean; label: string; text: string }) {
  return (
    <div style={{ borderRadius: 12, border: "1px solid var(--line)", background: "var(--card-2)", padding: "12px 14px" }}>
      <label style={{ display: "flex", alignItems: "center", gap: 9, cursor: "pointer", fontSize: 13.5, color: "var(--ink)" }}>
        <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} style={{ accentColor: "var(--accent)", width: 16, height: 16, flex: "none" }} />
        <span style={{ fontSize: 11, fontWeight: 600, color: required ? "var(--rose)" : "var(--ink-faint)", flex: "none" }}>{required ? "[필수]" : "[선택]"}</span>
        <span style={{ flex: 1 }}>{label}</span>
      </label>
      <details style={{ marginTop: 8 }}>
        <summary style={{ fontSize: 11.5, color: "var(--ink-faint)", cursor: "pointer" }}>전문 보기</summary>
        <div style={{ marginTop: 8, fontSize: 11.5, color: "var(--ink-dim)", lineHeight: 1.7, whiteSpace: "pre-wrap", maxHeight: 160, overflowY: "auto", padding: "10px 12px", borderRadius: 8, background: "var(--card)", border: "1px solid var(--line)" }}>
          {text}
        </div>
      </details>
    </div>
  );
}

export function TermsAgreement({ value, onChange }: { value: TermsState; onChange: (v: TermsState) => void }) {
  const allChecked = value.terms && value.privacy && value.marketing;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <label style={{ display: "flex", alignItems: "center", gap: 9, cursor: "pointer", fontSize: 13.5, fontWeight: 600, color: "var(--ink)", padding: "2px 2px 6px" }}>
        <input type="checkbox" checked={allChecked} onChange={(e) => onChange({ terms: e.target.checked, privacy: e.target.checked, marketing: e.target.checked })}
          style={{ accentColor: "var(--accent)", width: 16, height: 16, flex: "none" }} />
        전체 동의
      </label>
      <Row checked={value.terms} onChange={(v) => onChange({ ...value, terms: v })} required label="이용약관 동의" text={TERMS_TEXT} />
      <Row checked={value.privacy} onChange={(v) => onChange({ ...value, privacy: v })} required label="개인정보 수집·이용 동의" text={PRIVACY_TEXT} />
      <Row checked={value.marketing} onChange={(v) => onChange({ ...value, marketing: v })} required={false} label="마케팅 정보 수신 동의" text={MARKETING_TEXT} />
    </div>
  );
}
